/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

/**
 * Essential Cart Drawer locks body scrolling while its mobile drawer is open.
 * In a small number of mobile close interactions its `essential-cart__open`
 * state can outlive the close animation, leaving the page unscrollable.
 * Recover only after its own close control has been used and the drawer is
 * actually hidden; other drawers and modal scroll locks are left untouched.
 */
function initEssentialCartScrollRecovery() {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const restoreScroll = () => {
    if (!mobileQuery.matches) return;

    const drawer = document.querySelector(
      '#essential-cart-drawer-portal .essential-cart-drawer-container [role="dialog"]',
    );

    if (!drawer) return;

    const drawerStyles = window.getComputedStyle(drawer);
    const drawerIsOpen = drawerStyles.visibility !== 'hidden' && drawerStyles.pointerEvents !== 'none';

    if (drawerIsOpen) return;

    document.documentElement.classList.remove('essential-cart__open');
    document.documentElement.classList.add('essential-cart__closed');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const closeButton = event.target.closest(
        '#essential-cart-drawer-portal [data-essential-cart-element="cart-drawer-close-button"]',
      );

      if (!closeButton) return;

      // The app's close transition is 200 ms. A second check covers slower
      // mobile rendering without ever unlocking a still-visible drawer.
      window.setTimeout(restoreScroll, 300);
      window.setTimeout(restoreScroll, 600);
    },
    true,
  );
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

initEssentialCartScrollRecovery();
